
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic08Static as ObiHydraulic08StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-08-static.js';
 
 
 

 
 export const ObiHydraulic08Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-08-static',
   elementClass: ObiHydraulic08StaticElement,
   events: {
     
   }
  });
 
 